import React from 'react';

import {
  desktopOnly,
  mobileOnly,
  tabletOnly,
} from '@zola/zola-ui/src/styles/emotion/mixins/responsive';
import { useForceUpdateOnWindowResize } from '@zola/zola-ui/src/hooks';
import { Container, Marquee, Image } from './MarqueeHero.styles';

type MarqueeImage = {
  src: string;
  alt: string;
  height: number;
  width: number;
};

export type MarqueeHeroProps = {
  className?: string;
  images: {
    desktop: MarqueeImage[];
    tablet: MarqueeImage[];
    mobile: MarqueeImage[];
  };
};

const MarqueeHero = ({ className, images }: MarqueeHeroProps): JSX.Element => {
  useForceUpdateOnWindowResize();
  const desktopImages = images.desktop.concat(images.desktop);
  const tabletImages = images.tablet.concat(images.tablet);
  const mobileImages = images.mobile.concat(images.mobile);
  return (
    <Container className={className}>
      <Marquee>
        {desktopImages.map((i, idx) => (
          <Image
            css={desktopOnly}
            key={`${idx}-d1`}
            src={i.src}
            alt={i.alt}
            height={i.height}
            width={i.width}
          />
        ))}
        {tabletImages.map((i, idx) => (
          <Image
            css={tabletOnly}
            key={`${idx}-t1`}
            src={i.src}
            alt={i.alt}
            height={i.height}
            width={i.width}
          />
        ))}
        {mobileImages.map((i, idx) => (
          <Image
            css={mobileOnly}
            key={`${idx}-m1`}
            src={i.src}
            alt={i.alt}
            height={i.height}
            width={i.width}
          />
        ))}
      </Marquee>
    </Container>
  );
};

export default MarqueeHero;
